// step6.js - Cleaning & Maintenance Issues (Enhanced with photo upload support)
import ModernDataTable from '../ui/ModernDataTable';

const Step6 = ({
      cleaningMaintenanceItems,
      setCleaningMaintenanceItems,
      defaultDateTime,
      enablePhotoUpload,
      referenceNo,
      sectionName,
      dataTableRef
}) => {
      const cleaningMaintenanceFields = [
            {
                  name: 'timeRaised',
                  type: 'datetime',
                  label: 'Time raised',
                  header: 'Time raised',
                  required: true,
                  validationMessage: 'Please enter when the cleaning/maintenance issue was first identified',
                  hint: 'Record the exact time when the cleaning or maintenance issue was discovered or first reported.'
            },
            {
                  name: 'issueType',
                  type: 'dropdown',
                  label: 'Issue type',
                  header: 'Issue type',
                  placeholder: 'Select the type of issue',
                  options: [
                        { value: 'Cleaning - Spill/Mess', label: 'Cleaning - Spill/Mess' },
                        { value: 'Cleaning - Restroom', label: 'Cleaning - Restroom' },
                        { value: 'Cleaning - General Areas', label: 'Cleaning - General Areas' },
                        { value: 'Maintenance - Electrical', label: 'Maintenance - Electrical' },
                        { value: 'Maintenance - Plumbing', label: 'Maintenance - Plumbing' },
                        { value: 'Maintenance - Heating/Cooling', label: 'Maintenance - Heating/Cooling' },
                        { value: 'Maintenance - Structural', label: 'Maintenance - Structural' },
                        { value: 'Maintenance - Equipment', label: 'Maintenance - Equipment' },
                        { value: 'Other Cleaning Issue', label: 'Other Cleaning Issue' },
                        { value: 'Other Maintenance Issue', label: 'Other Maintenance Issue' },
                  ],
                  required: true,
                  validationMessage: 'Please select the appropriate issue type from the dropdown',
                  hint: 'Choose the category that best describes the type of cleaning or maintenance issue encountered.'
            },
            {
                  name: 'location',
                  type: 'text',
                  label: 'Location',
                  header: 'Location',
                  placeholder: 'Specific location where the issue occurred',
                  required: true,
                  validationMessage: 'Please specify the exact location where the issue occurred',
                  hint: 'Provide precise location details including level, section, room number, and any relevant landmarks.'
            },
            {
                  name: 'description',
                  type: 'textarea',
                  label: 'Describe the issue',
                  header: 'Description of issue',
                  placeholder: 'Describe the cleaning or maintenance issue that occurred...',
                  required: true,
                  validationMessage: 'Please provide a comprehensive description of the issue',
                  hint: (
                        <div>
                              <p style={{ margin: '0 0 0.5rem 0', fontWeight: '500' }}>Provide detailed information about:</p>
                              <ul style={{ margin: 0, paddingLeft: '1rem' }}>
                                    <li>Specific nature of the cleaning or maintenance problem</li>
                                    <li>Contributing factors or causes</li>
                                    <li>Extent and severity of the issue</li>
                                    <li>Environmental conditions at the time</li>
                                    <li>Any equipment or systems involved</li>
                                    <li>Impact on operations or safety</li>
                              </ul>
                        </div>
                  )
            },
            {
                  name: 'safetyHazard',
                  type: 'checkbox',
                  label: 'Safety measures implemented by EFS',
                  header: 'Safety measures implemented',
                  hint: 'Check this box if safety measures were required and implemented for this issue.',
                  displayTransform: (value) => value ? 'Yes - Safety Measures Implemented' : 'No'
            },
            {
                  name: 'safetyMeasures',
                  type: 'textarea',
                  label: 'Describe safety measures taken',
                  header: 'Safety measures',
                  placeholder: 'Describe the specific safety measures or precautions implemented...',
                  hideUntil: {
                        condition: (data) => data.safetyHazard === true
                  },
                  conditionalRequired: {
                        condition: (data) => data.safetyHazard === true,
                        message: 'Please describe the safety measures implemented'
                  },
                  hint: (
                        <div>
                              <p style={{ margin: '0 0 0.5rem 0', fontWeight: '500' }}>Document safety precautions including:</p>
                              <ul style={{ margin: 0, paddingLeft: '1rem' }}>
                                    <li>Area isolation or barriers installed</li>
                                    <li>Warning signs or notifications posted</li>
                                    <li>Personal protective equipment used</li>
                                    <li>Temporary alternative arrangements</li>
                                    <li>Staff or public safety briefings</li>
                                    <li>Emergency procedures activated</li>
                              </ul>
                        </div>
                  )
            },
            {
                  name: 'actionsTaken',
                  type: 'textarea',
                  label: 'Actions taken to resolve',
                  header: 'Actions taken',
                  placeholder: 'Describe actions taken to resolve the issue...',
                  required: false,
                  validationMessage: 'Please describe the actions taken to resolve this issue',
                  hint: (
                        <div>
                              <p style={{ margin: '0 0 0.5rem 0', fontWeight: '500' }}>Document resolution actions including:</p>
                              <ul style={{ margin: 0, paddingLeft: '1rem' }}>
                                    <li>Immediate cleanup or repair work</li>
                                    <li>Staff or contractors assigned</li>
                                    <li>Equipment or materials used</li>
                                    <li>Timeline for completion</li>
                                    <li>Follow-up actions required</li>
                                    <li>Preventive measures implemented</li>
                              </ul>
                        </div>
                  )
            }
      ];

      return (
            <ModernDataTable
                  suppressTitle={true}
                  data={cleaningMaintenanceItems}
                  setData={setCleaningMaintenanceItems}
                  fields={cleaningMaintenanceFields}
                  addButtonText="Add Cleaning/Maintenance Issue"
                  emptyMessage="No cleaning or maintenance issues added yet."
                  truncateLines={2}
                  defaultDateTime={defaultDateTime}
                  referenceNo={referenceNo}
                  sectionName={sectionName}
                  ref={dataTableRef}
            />
      );
};

export default Step6;